module.exports = __webpack_public_path__ + "static/media/m25b_thumb_even.de0d18d4.jpg";